<template>
    <el-form :model="form" :rules="rules" ref="form" v-if="show">
        <div id="payment-detail-reject-anchor"></div>
        <div class="detail-row footer">
            <div class="detail-block">
                <h3>退件</h3>
                <el-form-item prop="rsn" label="">
                    <el-input autofocus v-model="form.rsn" :rows="3" type="textarea" maxlength="200" show-word-limit placeholder="退件原因" ref="rsnInput"></el-input>
                </el-form-item>
            </div>
            <div style="text-align: right">
                <el-button type="dark" @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="handleSubmit" class="primary-action" :loading="isSubmitting">送出退件</el-button>
            </div>
        </div>
    </el-form>
</template>
<script>
export default {
    name: 'payment-reject',
    props: ['show', 'sno', 'audit'],
    data() {
        return {
            isSubmitting: false,
            form: {
                rsn: '',
            },
            rules: {
                rsn: [
                    {
                        required: true,
                        message: '請說明退件原因',
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    watch: {
        show(val) {
            if (!val) this.form.rsn = '';
        },
    },
    methods: {
        handleCancel() {
            this.$emit('canceled');
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const form = {
                        sno: this.sno,
                        rsn: this.form.rsn,
                        paY_BNK_SNO: null,
                        geN2_PAY_DAT: null,
                        taX_PAY_DAT: null,
                        audit: {
                            sno: this.audit.sno,
                            sot: this.audit.sot,
                            fin: 3,
                            rsn: this.form.rsn,
                            menU_UNT: this.audit.menU_UNT,
                        },
                    };

                    console.log('Payment Reject', form);
                    this.isSubmitting = true;
                    this.$api({
                        url: '/PaymentManagenmentPage/AuditPayment',
                        method: 'post',
                        data: form,
                    })
                        .then(() => {
                            this.$message({
                                showClose: true,
                                message: '請款單已退回申請人',
                                type: 'success',
                            });
                            this.$emit('submitted');
                        })
                        .catch((e) => {
                            console.log(e);
                            if (e.response.data === '重複操作，審核流程已更新。') {
                                this.$emit('submitted');
                            }
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                        });
                }
            });
        },
    },
};
</script>
